import { css } from "@emotion/react";
import React from "react";
import { useTheme } from "../theme";

export interface CardMediaProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * 画像のパスです。
   */
  src?: string;
  /**
   * ユーザビリティのためにあります。可能な限り指定してください。
   */
  alt?: string;
  /**
   * オーバーレイをかけます。またフォントカラーをオーバーレイの中で中で見やすい色に変化させます。
   * @default false
   */
  overlay?: boolean;
  children?: React.ReactNode;
}

export const CardMedia = ({
  children,
  src,
  alt,
  overlay,
  ...props
}: CardMediaProps) => {
  const { palette } = useTheme();
  return (
    <div
      {...props}
      css={css`
        box-sizing: border-box;
        display: block;
        background-image: url(${src});
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      `}
      title={alt}
    >
      <div
        css={[
          css`
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            height: 100%;
            padding: 16px;
          `,
          overlay &&
            css`
              color: ${palette.gray[50]};
              background-image: linear-gradient(
                rgba(0, 0, 0, 0.4),
                rgba(0, 0, 0, 0.3)
              );
            `,
        ]}
      >
        {children}
      </div>
    </div>
  );
};
